import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'
import Button from './Button'

import loginStyles from './styles/login.scss'

import illustration from './../assets/images/wopi-wide.png'

export default class AccountSetPassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      password: '',
      passwordAgain: '',
      isValid: false
    }
  }

  render() {
    const { title, formDescription, buttonText } = this.props
    const { showAccount, account, isLinkValid } = this.props

    return (
      <section className={loginStyles.login}>
        <Row>
          <Col sm={6} smOffset={3}>
            <h1>{title}</h1>

            {showAccount && account && this.renderAccountElement(account)}
            {isLinkValid && this.renderFormElement(formDescription, buttonText)}
            {!isLinkValid && this.renderNotFoundElement()}
          </Col>
        </Row>

        <p>
          <img src={illustration} alt="WOPI" />
        </p>
      </section>
    )
  }

  renderAccountElement(account) {
    return (
      <div>
        <h3 style={{ marginTop: 30 }}>{account.email}</h3>
      </div>
    )
  }

  renderFormElement(formDescription, buttonText) {
    return (
      <div>
        <p style={{ textAlign: 'left' }}>{formDescription}</p>

        <Row>
          <Col md={6}>
            <FormGroup controlId="password">
              <ControlLabel>{i18next.t('password')}</ControlLabel>
              <FormControl
                name="password"
                type="password"
                onChange={this.onChange.bind(this)}
                value={this.state.password}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup controlId="passwordAgain">
              <ControlLabel>{i18next.t('verify_password')}</ControlLabel>
              <FormControl
                name="passwordAgain"
                type="password"
                onChange={this.onChange.bind(this)}
                value={this.state.passwordAgain}
              />
            </FormGroup>
          </Col>
        </Row>

        <div>
          <Button
            text={buttonText}
            onClick={this.onSetPassword.bind(this)}
            disabled={!this.state.isValid}
          />
        </div>
      </div>
    )
  }

  renderNotFoundElement() {
    return <h3 style={{ marginTop: 30, textAlign: 'center' }}>{i18next.t('link_invalid')}</h3>
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => this.validateState())
  }

  validateState() {
    this.setState({
      isValid: this.state.password != '' && this.state.password === this.state.passwordAgain
    })
  }

  onSetPassword() {
    this.props.onSetPassword(this.state.password)
  }
}



// WEBPACK FOOTER //
// ./src/components/AccountSetPassword.js